<template>
  <section class="properties-section" :class="{ 'properties-section--has-actions': hasActions }">
    <section>
      <div class="properties-section-header">
        <h5>
          <span class="title-with-help">
            {{ title }}
            <span
              v-if="titleHelp"
              class="help-icon"
              :title="titleHelp"
              :aria-label="titleHelp"
            >?</span>
          </span>
        </h5>
        <div v-if="$slots.actions" class="properties-section-actions">
          <slot name="actions" />
        </div>
      </div>
      <div class="properties-section-body">
        <slot />
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    hasActions: {
      type: Boolean,
      default: false,
    },
    titleHelp: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.properties-section {
  display: flex;
  flex-direction: column;

  > section {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin: 1rem 0;
    background: white;
    border: 1px solid #C8D2DC;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 1.5rem;
    position: relative;

    .properties-section-header {
      align-items: flex-start;
      display: grid;
      gap: 1rem;
      grid-template-columns: minmax(0, 1fr) auto;
      margin: 0 0 1rem;

      h5 {
        font-weight: bold;
        margin: 0;
      }
    }

    .properties-section-actions {
      display: flex;
      justify-content: flex-end;
    }

    .title-with-help {
      align-items: center;
      display: inline-flex;
      gap: 0.35rem;
    }

    .help-icon {
      align-items: center;
      background: transparent;
      border: 1px solid #1275CC;
      border-radius: 50%;
      color: #1275CC;
      cursor: help;
      display: inline-flex;
      flex: 0 0 1.25rem;
      font-size: 0.75rem;
      font-weight: 700;
      height: 1.25rem;
      justify-content: center;
      line-height: 1;
      margin: 0;
      padding: 0;
      width: 1.25rem;
    }

    .properties-section-body {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      padding-left: 1rem;
    }

    label {
      font-weight: bold;

      &.confidentiality-label {
        font-weight: normal;
      }
    }

    input[type="text"],
    input[type="number"] {
      background: #f9f9f9;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      color: black;
      padding: 0.5rem 1rem;
    }

    input[type="checkbox"] {
      margin-right: 0.5rem;
    }
  }

  select {
    margin: 1rem 0;
  }

  .warning {
    color: #ef0000;
  }
}

.properties-section--has-actions > section {
  h5 {
    padding-right: 10.5rem;
  }

  .properties-section-body {
    padding-right: 10.5rem;
  }
}

@media (max-width: 900px) {
  .properties-section > section .properties-section-header {
    grid-template-columns: 1fr;
  }

  .properties-section > section .properties-section-actions {
    justify-content: flex-start;
  }

  .properties-section--has-actions > section {
    h5 {
      padding-right: 0;
    }

    .properties-section-body {
      padding-right: 0;
    }
  }
}
</style>
